<template>
  <div class="top-details">
    <v-container>
      <h2>{{displayRange}}</h2>
      <v-row>
        <v-col class="xs-12 bold">Total:</v-col>
        <v-skeleton-loader class="mx-auto" type="text" tile dark v-if="isLoading"></v-skeleton-loader>
        <v-col class="xs-12 bold" v-else>{{formatTotal}} DKK</v-col>
      </v-row>
      <v-row>
        <v-col>
          <range-selector></range-selector>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import RangeSelector from '@/components/RangeSelector.vue';

export default {
  props: ["total", "loading", "displayRange"],
  components: {
    RangeSelector
  },
  data() {
    return {
      isLoading: true
    };
  },
  computed: {
    formatTotal() {
      let number = parseFloat(this.total);
      return number.toFixed(2);
    },
  },
  watch: {
    loading(newValue) {
      this.isLoading = newValue;
    }
  }
};
</script>

<style lang="scss">
.top-details {
  width: 100%;
  position: fixed;
  top: 56px;
  background-color: #161e31;
  color: #fff;
  z-index: 1;
}
</style>